import { useAppSelector, useAppDispatch } from '../../../store/hooks'
import { selectOpenModal } from '../../../store/ui/uiSelectors'
import { setOpenModal } from '../../../store/ui/uiSlice'
import AccountSettingsModal from '../AccountSettingsModal/AccountSettingsModal'
import CreateWorkspaceModal from '../CreateWorkspaceModal/CreateWorkspaceModal'
import SelectWorkspaceModal from '../SelectWorkspaceModal/SelectWorkspaceModal'
import VerifyEmailModal from '../VerifyEmailModal/VerifyEmailModal'
import UpgradeToProModal from '../UpgradeToProModal/UpgradeToProModal'
import ProjectActivityModal from '../ProjectActivityModal/ProjectActivityModal'
import TaskActivityModal from '../TaskActivityModal/TaskActivityModal'
import PublishProjectModal from '../PublishProjectModal/PublishProjectModal'
import ProjectMembersModal from '../ProjectMembersModal/ProjectMembersModal'
import GlobalSearchModal from '../GlobalSearchModal/GlobalSearchModal'

const ModalRouter = () => {
    const dispatch = useAppDispatch()
    const openModal = useAppSelector(selectOpenModal)

    const handleClose = () => {
        dispatch(setOpenModal(null))
    }

    if (!openModal) return null

    switch (openModal.type) {
        case 'accountSettings':
            return <AccountSettingsModal onClose={handleClose} />
        case 'createWorkspace':
            return <CreateWorkspaceModal onClose={handleClose} canClose={openModal.canClose} />
        case 'selectWorkspace':
            return <SelectWorkspaceModal onClose={handleClose} canClose={openModal.canClose} />
        case 'verifyEmail':
            return <VerifyEmailModal email={openModal.email} />
        case 'upgradeToPro':
            return <UpgradeToProModal onClose={handleClose} />
        case 'projectActivity':
            return <ProjectActivityModal projectId={openModal.projectId} onClose={handleClose} />
        case 'taskActivity':
            return <TaskActivityModal taskId={openModal.taskId} onClose={handleClose} />
        case 'publishProject':
            return <PublishProjectModal projectId={openModal.projectId} onClose={handleClose} />
        case 'projectMembers':
            return <ProjectMembersModal projectId={openModal.projectId} onClose={handleClose} />
        case 'search':
            return <GlobalSearchModal onClose={handleClose} />
        default:
            return null
    }
}

export default ModalRouter
